export interface AddTimesheet {
  project_track_id: string;
  task_track_id: string;
  activity_track_id: string;
  hours: string;
  minutes: string;
  timesheet_date: Date | string;
  worktype: string;
  work_description: string;
  // time_range: string;
  // fromTime: string;
  // toTime: string;
  timesheet_id: string;
}

export interface TaskListTs {
  client_id: string;
  closedBy: string;
  project_name: string;
  communication_date: Date | string;
  communication_hourmin: string;
  communication_received_from: string;
  communication_send_to: string;
  createdBy: string;
  createdOn: Date | string;
  email_subject: string;
  event_attendies: string;
  id: string;
  project_id: string;
  task_alert_require: string;
  task_comments: string;
  task_end_date: Date | string;
  task_hours: string;
  task_priority: string;
  task_start_date: Date | string;
  task_status: string;
  task_title: string;
  task_type_id: string;
  task_uniqueid: string;
  project_shortname: string;
}

export interface ProjectListTs {
  // taskDetail: { project_id: string; project_name: string }[];
  // task_id: string;
  project_id: string;
  project_name: string;
}

export interface ActivityListTs {
  activity_id: string;
  activity_name: string;
}

export interface DefaultTimsheetList {
  tmid: string;
  project_track_id: string;
  module_track_id: string;
  task_track_id: string;
  user_track_id: string;
  activity_track_id: string;
  timespent: string;
  worktype: string;
  work_description: string;
  timesheet_date: string | Date;
  time_range: string;
  time_insert_datetime: string | Date;
  time_update_datetime: string | Date;
  tm_archive_status: string;
  timesheet_flag: string;
  project_name: string;
  task_name: string;
  task_uniqueid: string;
  activity_name: string;
  project_shortname: string;
}

export interface ModifiedTimesheetList {
  date: string | Date;
  data: DefaultTimsheetList[];
  totalHours: string | number;
}

export interface TimesheetOverviewEntry {
  timesheetId: number;
  hours: number;
  timesheet_date: string;
  comment: string;
}

export interface TimesheetOverviewUser {
  userId: number;
  name: string;
  dates: { [date: string]: TimesheetOverviewEntry[] };
  totalHours: number;
}

/** The timesheetList API returns a double-nested data object */
export interface TimesheetOverviewApiData {
  status: boolean;
  message: string;
  data: TimesheetOverviewUser[];
}
